import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, of, ReplaySubject } from 'rxjs';
import { finalize, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { NextcloudFile } from 'src/app/classes';
import { SelectFileViewDialogComponent, FileViewModes } from 'src/app/lib/nextcloud/components/dialog/select-file-view-dialog/select-file-view-dialog.component';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { NextcloudPathInfo } from 'src/app/lib/nextcloud/classes';
import { FileService } from 'src/app/lib/nextcloud/services/file.service';
import { AbstractWidgetInner, WidgetInnerView } from 'src/app/widget-inner';
import { InputDialogComponent, InputDialogComponentInput } from 'src/app/lib/shared/components/dialog/input-dialog/input-dialog.component';
import { RootService } from 'src/app/services/root.service';

@Component({
  selector: 'app-file-explorer-widget-inner',
  templateUrl: './file-explorer-widget-inner.component.html',
  styleUrls: ['./file-explorer-widget-inner.component.css']
})
export class FileExplorerWidgetInnerComponent extends AbstractWidgetInner {

  private _currentLocation = new BehaviorSubject('/');
  set currentLocation(location: string) {
    this._currentLocation.next(location);
  }
  pathInfo$: Observable<NextcloudPathInfo> = this._currentLocation.pipe(switchMap((location) => this._fileService.getRelativePath(location)), shareReplay(1));
  files$ = this.pathInfo$.pipe(switchMap((info: NextcloudPathInfo) => {
    this._loading.next(true);
    return this._fileService.getFolderByPath(info.convertedPath).pipe(
      tap(files => {
        if(Array.isArray(files)){
          this.root = files.find(x => x.isItself);
          this._loading.next(false);
        }
      })
    );
  }));
  rootPathArray$ = this.pathInfo$.pipe(map((info) => Array.isArray(info.prettyPathArray) ? info.prettyPathArray : []));
  rootName$ = this.pathInfo$.pipe(map(x => x.rootFolderName ? x.rootFolderName : 'Ordner'));

  private _rootSize = new ReplaySubject<string>(1);
  prettyRootSize$ = this._rootSize.pipe(map(x => FileService.prettyFileSize(x)))

  set root(root: NextcloudFile) {
    this._rootSize.next(root ? root.size : null);
  }

  fileFilter: string;
  files: NextcloudFile[] = [];
  enableNavigation: boolean = true;

  private _loading = new BehaviorSubject(false);
  loading$ = this._loading.asObservable();

  viewMode: number = FileViewModes.List;

  constructor(
    @Inject(WIDGET_PROVIDER_SERVICE) private _widgetProviderService: IWidgetProviderService,
    private _fileService: FileService,
    private _dialog: MatDialog,
    private _rootService: RootService
  ) {
    super();
  }

  changeView() {
    this._dialog.open(SelectFileViewDialogComponent, {
      panelClass: "no-padding-dialog-container",
      autoFocus: false,
      data: this.viewMode
    }).afterClosed().subscribe((result: number) => {
      this.viewMode = result;
      console.log(result);
    });
  }

  fileClick(file: NextcloudFile) {
    console.log(file);
    this._fileService.getRelativePath(file.href).subscribe((result) => {
      if (result.isFolder) this.currentLocation = file.href;
      else this._fileService.previewFile(file);
    });
  }

  ngOnInit(): void {
    this._widgetProviderService.setWidgetInnerViews([
      {
        name: () => of('Ansicht ändern'),
        icon: () => of('widgets'),
        onClick: () => {
          this.changeView();
          return of(null);
        }
      } as WidgetInnerView,
      {
        name: () => of('Ordner anlegen'),
        icon: () => of('create_new_folder'),
        onClick: () => {
          return this._dialog.open(InputDialogComponent, {
            panelClass: 'no-padding-dialog-container',
            data: { headline: 'Ordnerbezeichnung wählen', label: 'Ordnerbezeichnung', minLength: 3 } as InputDialogComponentInput
          }).afterClosed()
            .pipe(
              switchMap((result: string) => typeof result === 'string' ? (this._fileService.createNewFolder(`${this._currentLocation.value}/${result}`) as Observable<any>) : of(null)),
              finalize(() => this.refresh())
            );
        }
      } as WidgetInnerView,
      {
        name: () => of('Datei hochladen'),
        icon: () => of('upload'),
        onClick: () => {
          return this._rootService.uploadFiles(this._currentLocation.value).pipe(switchMap((result) => {
            this.refresh();
            return of(null);
          }));
        }
      } as WidgetInnerView
    ]);
  }

  pathNavigatorChanged = (pathArray: string[]) => this.currentLocation = pathArray.join('/');

  refresh = () => this.currentLocation = this._currentLocation.value;

}
